<div class="app-es-ocr-quick-fix-main-shipment-details">
  <!--Shipment Details-->
  <app-section-form-block-layout
    [formGroup]="formGroup"
    headerTitle="LABELS.SHIPMENT_DETAILS"
    [isHeaderTitleUpperCase]="true"
    infoTooltip="LABELS.EDIT_SHIPMENT_DETAILS_DESCRIPTION"
    [fields]="shipmentDetailsFields"
    [displayErrors]="displayErrors"
    [formErrors]="formErrors"
    [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(shipmentDetailsFields)"
    editBlockClass="normal-gap"
  >
    <div
      edit-block-header
      class="app-es-ocr-quick-fix-main-shipment-details__shipment-type"
      [ngClass]="{ 'app-es-ocr-quick-fix-main-shipment-details__shipment-type--with-truck': isTruckTileVisible }"
    >
      <div
        class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item"
        [ngClass]="{ 'is-active': isAir }"
        (click)="onShipmentTypeSelect(enumTransportationMode.AIR)"
      >
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-icon">
          <img src="assets/icons/ic_plain.svg" />
        </div>
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-text">
          {{ "LABELS.AIR" | translate }}
        </div>
      </div>

      <div
        class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item"
        [ngClass]="{ 'is-active': isOcean }"
        (click)="onShipmentTypeSelect(enumTransportationMode.OCEAN)"
      >
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-icon">
          <img src="assets/icons/vessel.svg" />
        </div>
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-text">
          {{ "LABELS.OCEAN" | translate }}
        </div>
      </div>

      <div
        class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item"
        [ngClass]="{ 'is-active': isRail }"
        (click)="onShipmentTypeSelect(enumTransportationMode.RAIL)"
      >
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-icon">
          <img src="assets/icons/rail.svg" />
        </div>
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-text">
          {{ "LABELS.RAIL" | translate }}
        </div>
      </div>

      <!-- #13422: Truck is a beta feature (es_trucker_integration) — see isTruckTileVisible -->
      <div
        *ngIf="isTruckTileVisible"
        class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item"
        [ngClass]="{ 'is-active': isTruck }"
        (click)="onShipmentTypeSelect(enumTransportationMode.TRUCK)"
      >
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-icon">
          <img src="assets/icons/icon_truck.svg" />
        </div>
        <div class="app-es-ocr-quick-fix-main-shipment-details__shipment-type__item-text">
          {{ "TRUCK" | translate }}
        </div>
      </div>
    </div>
  </app-section-form-block-layout>

  <!--From-->
  <app-section-form-block-layout
    [formGroup]="formGroup"
    headerTitle="LABELS.FROM"
    [isHeaderTitleUpperCase]="true"
    infoTooltip="LABELS.EDIT_SHIPMENT_DETAILS_FROM_HINT"
    [fields]="fromFields"
    [displayErrors]="displayErrors"
    [formErrors]="formErrors"
    [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(fromFields)"
    editBlockClass="normal-gap"
  ></app-section-form-block-layout>

  <!--To-->
  <app-section-form-block-layout
    [formGroup]="formGroup"
    headerTitle="LABELS.TO"
    [isHeaderTitleUpperCase]="true"
    infoTooltip="LABELS.EDIT_SHIPMENT_DETAILS_TO_HINT"
    [fields]="toFields"
    [displayErrors]="displayErrors"
    [formErrors]="formErrors"
    [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(toFields)"
    editBlockClass="normal-gap"
  ></app-section-form-block-layout>

  <!--Via Checkbox-->
  <app-section-form-block-layout
    *ngIf="!isTruck"
    [formGroup]="formGroup"
    headerTitle="ENTRY_SUMMARY.VIA"
    [isHeaderTitleUpperCase]="true"
    infoTooltip="LABELS.EDIT_SHIPMENT_DETAILS_VIA_HINT"
    [fields]="[viaFields[0]]"
    [displayErrors]="displayErrors"
    [formErrors]="formErrors"
    [isShowEditButton]="false"
    [isEditBlockOpenByDefault]="true"
  >
    <div edit-block-footer *ngIf="formGroup.get(viaFields[0].name).value" class="col-12 mt-2">
      <!--Port of unlading-->
      <auto-select
        infoTooltip="FORM_HELPER.PORT_OF_UNLADING_ARRIVAL"
        [label]="viaFields[1].label"
        [bindLabel]="viaFields[1]?.bindLabel"
        [bindValue]="viaFields[1]?.bindValue"
        [change]="viaFields[1]?.change"
        [id]="viaFields[1]?.id"
        [initializeItems]="viaFields[1]?.initializedItems"
        [errors]="formErrors[viaFields[1].name]"
        [fc]="formGroup.get(viaFields[1].name)"
        [helper]="viaFields[1]?.helper"
        [placeholder]="viaFields[1]?.placeholder | translate"
      ></auto-select>
    </div>
  </app-section-form-block-layout>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
